import { useAsyncExecutor } from "async-executor-hook";
import { useContext, useState } from "react";
import { useEffect } from "react";
import { of } from "rxjs";
import { API } from "../../utils/api";
import Input from "../Input/Input";
import { QuejaReclamoContext } from "../QuejaReclamoContext/QuejaReclamoContext";
import Select from "../Select/Select";
import { Grid, MainButton, Subtitle } from "./CreateComplainantIdStyles";

const LIMIT_DNI = 8;
const LIMIT_RUC = 11;
const LIMIT_PASSPORT = 12;
const LIMIT_CE = 12;
const LIMIT_PHONE = 7;
const LIMIT_MOBILE = 9;

const INPUT_NUMERIC = "^[0-9]*$";
const INPUT_ALPHANUMERIC = "^[a-zA-Z0-9]*$";

function CreateComplainantId(props) {
  const loadProfile = useAsyncExecutor(
    () => {
      return fetch(`${API.BACKEND.URL}/api/login/me/`, {
        headers: new Headers({
          Authorization: `bearer ${localStorage.getItem("accessToken")}`,
          accept: "application/json",
        }),
      }).then((resp) => resp.json());
    },
    {
      source$: of({}),
      onSuccess: (user) => {
        if (user.category === "agent_user") {
          updateComplainantId({
            ...complainantId,
            name: user.full_name,
            mail: user.email,
          });
        }
      },
    }
  );

  const { onFinished } = props;

  const [complainantId, updateComplainantId] = useContext(QuejaReclamoContext);

  const [errorName, updateErrorName] = useState(false);
  const [errorDocumentType, updateErrorDocumentType] = useState(false);
  const [errorDocumentId, updateErrorDocumentId] = useState(false);
  const [errorPhone, updateErrorPhone] = useState(false);
  const [errorRole, updateErrorRole] = useState(false);
  const [errorMail, updateErrorMail] = useState(false);
  const [limitDocumentId, updateLimitDocumentId] = useState(0);
  const [typeDocumentId, updateTypeDocumentId] = useState("");

  const onClick = () => {
    if (complainantId.name.length === 0) updateErrorName(true);
    if (complainantId.documentType.length === 0) updateErrorDocumentType(true);
    if (complainantId.documentId.length === 0) updateErrorDocumentId(true);
    if (complainantId.phoneNumber === "" || complainantId.phoneNumber === null)
      updateErrorPhone(true);
    if (complainantId.role.length === 0) updateErrorRole(true);
    if (complainantId.mail.length === 0) updateErrorMail(true);
    if (
      complainantId.name.length !== 0 &&
      complainantId.documentType.length !== 0 &&
      complainantId.documentId.length !== 0 &&
      complainantId.phoneNumber !== "" &&
      complainantId.phoneNumber !== null &&
      complainantId.role.length !== 0 &&
      complainantId.mail.length !== 0
    ) {
      onFinished();
    }
  };

  const onNameChange = (ev) => {
    if (errorName) updateErrorName(false);
    updateComplainantId({ ...complainantId, name: ev.target.value });
  };
  const onDocumentTypeChange = (ev) => {
    if (errorDocumentType) updateErrorDocumentType(false);
    if (ev.target.value === "DNI") {
      updateLimitDocumentId(LIMIT_DNI);
      updateTypeDocumentId(INPUT_NUMERIC);
    }
    if (ev.target.value === "RUC") {
      updateLimitDocumentId(LIMIT_RUC);
      updateTypeDocumentId(INPUT_NUMERIC);
    }
    if (ev.target.value === "CE") {
      updateLimitDocumentId(LIMIT_CE);
      updateTypeDocumentId(INPUT_ALPHANUMERIC);
    }
    if (ev.target.value === "PASSPORT") {
      updateLimitDocumentId(LIMIT_PASSPORT);
      updateTypeDocumentId(INPUT_ALPHANUMERIC);
    }
    updateComplainantId({
      ...complainantId,
      documentType: ev.target.value,
      documentId: "",
    });
  };

  const onDocumentIdChange = (ev) => {
    if (ev.target.value.length > limitDocumentId) return;
    if (!ev.target.value.match(typeDocumentId)) return;
    if (errorDocumentId) updateErrorDocumentId(false);
    updateComplainantId({ ...complainantId, documentId: ev.target.value });
  };

  const onPhoneChange = (ev) => {
    if (ev.target.value.length > LIMIT_PHONE) return;
    if (errorPhone) updateErrorPhone(false);
    updateComplainantId({ ...complainantId, phoneNumber: ev.target.value });
  };
  const onMobileChange = (ev) => {
    if (ev.target.value.length > LIMIT_MOBILE) return;
    updateComplainantId({ ...complainantId, mobileNumber: ev.target.value });
  };

  const [isValid, setIsValid] = useState(false);
  const [message, setMessage] = useState("");

  const emailRegex = /\S+@\S+\.\S+/;

  const onMailChange = (ev) => {
    updateComplainantId({ ...complainantId, mail: ev.target.value });

    if (loadProfile.data.category !== "agent_user") {
      const email = ev.target.value;
      if (emailRegex.test(email)) {
        setIsValid(true);
        setMessage("");
      } else {
        setIsValid(false);
        setMessage("Ingrese un correo válido");
      }
    }
  };

  const onRoleChange = (ev) => {
    if (errorRole) updateErrorRole(false);
    updateComplainantId({ ...complainantId, role: ev.target.value });
  };

  const [disabledButtonActive, setDisabledButtonActive] = useState(false);

  useEffect(() => {
    const isButtonDisabled =
      complainantId.name.length === 0 ||
      complainantId.documentType.length === 0 ||
      complainantId.documentId.length === 0 ||
      complainantId.phoneNumber.length === 0 ||
      complainantId.role.length === 0 ||
      complainantId.mail.length < 1;
    if (complainantId.mail.length > 0) updateErrorMail(false);
    setDisabledButtonActive(isButtonDisabled);
    if (loadProfile.data?.category === "agent_user") {
      setDisabledButtonActive(isButtonDisabled);
    } else {
      setDisabledButtonActive(isButtonDisabled || !isValid);
    }
    // eslint-disable-next-line
  }, [complainantId]);

  return (
    <Grid>
      {loadProfile.isLoading && <>PROCESANDO...</>}

      {loadProfile.isSuccess && (
        <>
          <div className="model">
            <Subtitle>Nombre(s) y Apellidos (*)</Subtitle>
            <Input
              width="34.8rem"
              height="5rem"
              value={complainantId.name}
              onChange={onNameChange}
              placeholder="Nombre y Apellido"
              hasError={errorName}
              disabled={loadProfile.data.category === "agent_user"}
            />
          </div>

          <div className="model">
            <Subtitle>Tipo de documento (*)</Subtitle>
            <Select
              className="clickable-element"
              width="34.8rem"
              height="5rem"
              value={complainantId.documentType}
              onChange={onDocumentTypeChange}
              hasError={errorDocumentType}
            >
              <option value="" disabled>
                (Seleccione un tipo de documento)
              </option>
              <option value="DNI">DNI</option>
              <option value="PASSPORT">Pasaporte</option>
              <option value="CE">Carnet de extranjería</option>
              <option value="RUC">RUC</option>
            </Select>
          </div>
          <div className="model">
            <div>
              <Subtitle>Número de documento (*)</Subtitle>
              <Input
                width="34.8rem"
                height="5rem"
                value={complainantId.documentId}
                onChange={onDocumentIdChange}
                placeholder="Número de documento"
                hasError={errorDocumentId}
              />
            </div>
          </div>
          <div className="model">
            <Subtitle>Teléfono (*)</Subtitle>
            <Input
              width="34.8rem"
              height="5rem"
              value={complainantId.phoneNumber}
              onChange={onPhoneChange}
              type="number"
              placeholder="Número telefónico"
              hasError={errorPhone}
            />
          </div>
          <div className="model">
            <Subtitle>Celular</Subtitle>
            <Input
              width="34.8rem"
              height="5rem"
              value={complainantId.mobileNumber}
              onChange={onMobileChange}
              type="number"
              placeholder="Número de celular"
            />
          </div>
          <div className="model">
            <Subtitle>Correo electrónico (*)</Subtitle>
            <Input
              width="34.8rem"
              height="5rem"
              value={complainantId.mail}
              onChange={onMailChange}
              placeholder="example@mail.com"
              hasError={errorMail}
              disabled={loadProfile.data.category === "agent_user"}
            />
            <div
              style={{
                color: `${isValid ? "blue" : "red"}`,
                fontFamily: "Montserrat",
                fontSize: "1.4rem",
              }}
            >
              {message}
            </div>
          </div>
          <div className="model">
            <Subtitle>Rubro (*)</Subtitle>
            <Select
              className="clickable-element"
              width="34.8rem"
              height="5rem"
              value={complainantId.role}
              onChange={onRoleChange}
              hasError={errorRole}
            >
              <option value="" disabled>
                (Seleccione un cargo)
              </option>
              <option value="CUSTOM_AGENT">Agencia de carga</option>
              <option value="CUSTOMS_ADUANA">Agencia de aduanas</option>
              <option value="IMPORTER">Importador</option>
              <option value="EXPORTER">Exportador</option>
              <option value="AIRLINE">Aerolínea</option>
              <option value="OTHER">Otro</option>
            </Select>
          </div>
          <div className="button--container">
            <MainButton isDisabled={disabledButtonActive} onClick={onClick}>
              Siguiente
            </MainButton>
          </div>
        </>
      )}
    </Grid>
  );
}

export default CreateComplainantId;
